/* eslint-disable linebreak-style */
import React, { useEffect } from 'react';

interface IFireworksProps {
  isTriggerFireworks: boolean;
  setIsTriggerFireworks: (isTriggerFireworks: boolean) => void;
}

export const Fireworks: React.FC<IFireworksProps> = ({ isTriggerFireworks, setIsTriggerFireworks }) => {
  useEffect(() => {
    if (isTriggerFireworks) {
      // @ts-ignore
      const fw = window.$('#root').fireworks();

      const timeoutId = setTimeout(() => {
        fw.fireworks('destroy');
        setIsTriggerFireworks(false);
      }, 8000);
      return () => clearTimeout(timeoutId);
    }
    return () => {};
  }, [isTriggerFireworks, setIsTriggerFireworks]);

  return null;
};
